import { Typography, Box, Grid2 as Grid } from '@mui/material';
import { FC } from 'react';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput, PasswordInput, Talroo, TalrooPixel, PhoneInput } from '@carcareers/components';

export const AccountInformationStep: FC = () => {
  const { data } = useForm<JobseekerCreateDto>();

  return (
    <>
      <Talroo pixel={TalrooPixel.CREATE_PROFILE} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
          Account Information
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextInput required label="First Name" name="user.firstName" autoComplete="given-name" fullWidth />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextInput required label="Last Name" name="user.lastName" autoComplete="family-name" fullWidth />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextInput
              required
              label="Email"
              name="user.email"
              type="email"
              autoComplete="email"
              disabled={data?.user?.isEmailVerified}
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <PhoneInput required label="Phone Number" name="user.phone" autoComplete="tel" fullWidth />
          </Grid>
        </Grid>
        <PasswordInput />
      </Box>
    </>
  );
};

export default AccountInformationStep;
